export const environment = {
  production: false,
  apiUrl: 'http://api.homolog.slenderbank.com/api',
  apiAuthUrl: 'http://api.homolog.slenderbank.com'
};
